"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWrapperSubscribableDatasetFactory = void 0;
var createExtendedDataset_1 = __importDefault(require("./createExtendedDataset"));
var WrapperSubscribableDatasetFactory_1 = __importDefault(require("./WrapperSubscribableDatasetFactory"));
/**
 * Creates a dataset factory that generates a SubscribableDataset
 * @returns DatasetFactory for SubscribableDataset
 */
function createWrapperSubscribableDatasetFactory() {
    var datasetFactory = {
        dataset: function (quads) {
            return (0, createExtendedDataset_1.default)(quads);
        },
    };
    return new WrapperSubscribableDatasetFactory_1.default(datasetFactory);
}
exports.createWrapperSubscribableDatasetFactory = createWrapperSubscribableDatasetFactory;
/**
 * Creates a SubscribableDataset
 * @param quads: A dataset or array of Quads to initialize the dataset.
 * @returns Dataset
 */
function createWrapperSubscribableDataset(quads) {
    var wrapperSubscribableDatasetFactory = createWrapperSubscribableDatasetFactory();
    return wrapperSubscribableDatasetFactory.dataset(quads);
}
exports.default = createWrapperSubscribableDataset;
